import VideoArtFinishPage from './VideoArtFinishPage'

export default VideoArtFinishPage
